/**
 * oneForAll completed messages expose finalSignedDocUrl (all signatures).
 * Per-signer signedDocUrl may still be an intermediate revision (OMM-715).
 * onePerMember must keep the per-user copy — older rows can still have a stale
 * finalSignedDocUrl from the last signer.
 *
 * @param {{ digitalSignature?: boolean, signingMode?: string, finalSignedDocUrl?: string, acknowledges?: Array<{ user?: string, signedDocUrl?: string }> }|null|undefined} message
 * @param {string} [userId]
 * @param {string|null} [fallbackUrl]
 * @returns {string|null|undefined}
 */
export default function resolveSignedDocumentUrl(message, userId, fallbackUrl) {
  if (
    message?.digitalSignature &&
    message.signingMode === 'oneForAll' &&
    message.finalSignedDocUrl
  ) {
    return message.finalSignedDocUrl;
  }
  const acknowledge = (message?.acknowledges || []).find(
    ack => ack?.user != null && String(ack.user) === String(userId),
  );
  return acknowledge?.signedDocUrl || fallbackUrl;
}
